import { render, staticRenderFns } from "./coverImage.vue?vue&type=template&id=72fb90bc&scoped=true&"
import script from "./coverImage.vue?vue&type=script&lang=ts&"
export * from "./coverImage.vue?vue&type=script&lang=ts&"
import style0 from "./coverImage.vue?vue&type=style&index=0&id=72fb90bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fb90bc",
  null
  
)

export default component.exports